import axios from 'axios'

/**
 * API тренажеров для работы с сервером
 *
 */
class serverApi {
  /**
   * Получить список тренажеров
   *
   * @static
   * @param {number} perPage
   * @param {number} pageNumber
   * @param {Array} filters
   * @param {Array} sorting
   * @returns {Promise}
   */
  static getTrainingList(perPage, pageNumber, filters, sorting) {
    const query = {
      params: {
        perPage,
        pageNumber,
        filters,
        sorting
      }
    }
    return axios.get('/api/education/simulators', query)
  }

  /**
   * Добавить тренажер
   *
   * @static
   * @returns {Promise}
   */
  static addTraining() {
    return axios.post('/api/education/simulators')
  }

  /**
   * Получить содержимое тренажера
   *
   * @static
   * @param {number} id
   * @returns {Promise}
   */
  static getTrainingContent(id) {
    return axios.get(`/api/education/simulators/${id}`)
  }

  /**
   * Удалить тренажер
   *
   * @static
   * @param {number} id
   * @returns {Promise}
   */
  static deleteTraining(id) {
    return axios.delete(`/api/education/simulators/${id}`)
  }

  /**
   * Обновить тренажер
   *
   * @static
   * @param {number} id
   * @param {Object} newTraining
   * @returns {Promise}
   */
  static updateTraining(id, newTraining) {
    return axios.put(`/api/education/simulators/${id}`, newTraining)
  }

  /**
   * Удалить пульт
   *
   * @static
   * @param {number} simulatorId
   * @param {number} panelId
   * @returns {Promise}
   */
  static deletePanel(simulatorId, panelId) {
    return axios.delete(
      `/api/education/simulators/${simulatorId}/panels/${panelId}`,
    )
  }

  /**
   * Удалить ресурс
   *
   * @static
   * @param {number} simulatorId
   * @param {number} resourceId
   * @returns {Promise}
   */
  static deleteResource(simulatorId, resourceId) {
    return axios.delete(
      `/api/education/simulators/${simulatorId}/resources/${resourceId}`,
    )
  }

  /**
   * Получить JSON-схему
   *
   * @static
   * @param {string} schema Название схемы
   * @returns {Promise}
   */
  static getSchema(schema) {
    return axios.get(`/json/${schema}`)
  }

  /**
   * Получить аудио-файл в формате Blob
   *
   * @static
   * @param {string} url url аудио-файла
   * @returns {Promise}
   */
  static getAudioBlob(url) {
    return axios.get(url, {
      responseType: 'blob'
    })
  }

  /**
   * Получить gif-файл в формате arraybuffer
   *
   * @static
   * @param {string} url url gif-файла
   * @returns {Promise}
   */
  static getGif(url) {
    return axios.get(url, {
      responseType: 'arraybuffer'
    })
  }
}

export default serverApi
